import { ConfigProvider } from 'antd'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import App from './pages/App'
import ErrorPage from './pages/ErrorPage'
import './index.scss'

const route = createBrowserRouter([
    { path: '/', element: <App />, errorElement: <ErrorPage /> },
    { path: '/:formId', element: <App />, errorElement: <ErrorPage /> },
])
const root = document.getElementById('root')
if (root) {
    ReactDOM.createRoot(root).render(
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        colorPrimary: '#F18532',
                        algorithm: true,
                    },
                },
            }}
        >
            <RouterProvider router={route} />
        </ConfigProvider>
    )
}
